import { render, staticRenderFns } from "./Choppers.vue?vue&type=template&id=565ccf20&scoped=true&"
import script from "./Choppers.vue?vue&type=script&lang=js&"
export * from "./Choppers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ccf20",
  null
  
)

export default component.exports